import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailAlertLibModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/email-alert/email-alert.module';
import { SharedModule } from '../../../shared/shared.module';
import { CustomerNavigationModule } from '../customer-navigation/customer-navigation.module';
import { EmailAlertsScreenComponent } from './screens/email-alerts-screen/email-alerts-screen.component';

@NgModule({
  declarations: [EmailAlertsScreenComponent],
  imports: [CommonModule, SharedModule, EmailAlertLibModule, CustomerNavigationModule],
  exports: [EmailAlertsScreenComponent],
})
export class EmailAlertsModule {}
